import { render, staticRenderFns } from "./LoginCenter.vue?vue&type=template&id=238e75a6"
import script from "./LoginCenter.vue?vue&type=script&lang=js"
export * from "./LoginCenter.vue?vue&type=script&lang=js"
import style0 from "./LoginCenter.vue?vue&type=style&index=0&id=238e75a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports